import { CommonModule } from '@angular/common';
import { forwardRef, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule, Routes } from '@angular/router';
import { ElmChipModule } from '@element451-libs/components451/chip';
import { ElmEmptyStateModule } from '@element451-libs/components451/empty-state';
import { ElmIconModule } from '@element451-libs/components451/icon';
import { ElmProgressSpinnerModule } from '@element451-libs/components451/progress-spinner';
import {
  Page451ComponentsModule,
  Page451EditorCoreModule,
  Page451FontsExtractorService,
  PageClickStrategy
} from '@element451-libs/page451-lib';
import { Page451RowsModule } from '@element451-libs/page451-rows';
import { FragmentPolyfillModule } from '@element451-libs/utils451/fragment-polyfill';
import { PipesModule } from '@element451-libs/utils451/pipes';
import { TokensModule } from '@element451-libs/utils451/tokens';
import { TranslocoModule } from '@jsverse/transloco';
import {
  ActionCardModule,
  AppStatusChipModule,
  UserActionsModule
} from '../components';
import { HomeStoreModule } from './+state';
import {
  ApplicationListComponent,
  ApplicationListItemComponent
} from './components';
import {
  ApplicationHeaderComponent,
  ApplicationsPanelComponent,
  HomeComponent
} from './containers';
import {
  App451TokensService,
  AppClientClickStrategy,
  ApplicationListService,
  RowsProxyService
} from './services';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslocoModule,
    FlexLayoutModule,
    HomeStoreModule,

    ElmEmptyStateModule,
    ElmProgressSpinnerModule,
    ElmIconModule,
    ElmChipModule,

    ActionCardModule,
    AppStatusChipModule,
    UserActionsModule,

    FragmentPolyfillModule.forRoot(),
    TokensModule.forRoot(forwardRef(() => App451TokensService)),
    PipesModule,

    Page451EditorCoreModule.staticMode(),
    Page451ComponentsModule.forRoot(),
    Page451RowsModule.withProxy(RowsProxyService)
  ],
  declarations: [
    ApplicationListItemComponent,
    ApplicationListComponent,
    ApplicationsPanelComponent,
    ApplicationHeaderComponent,
    HomeComponent
  ],
  exports: [HomeComponent],
  providers: [
    { provide: App451TokensService, useClass: App451TokensService },
    { provide: PageClickStrategy, useClass: AppClientClickStrategy },
    ApplicationListService,
    Page451FontsExtractorService
  ]
})
export class HomeModule {}
